function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bag",
  d: "M12.294,6.116H8.928V4.736a4.736,4.736,0,0,0-9.471,0v1.38H-4.188a.547.547,0,0,0-.546.546v14.61A2.729,2.729,0,0,0-2.006,24H10.117a2.729,2.729,0,0,0,2.728-2.728V6.662a.552.552,0,0,0-.551-.546ZM.542,4.731a3.645,3.645,0,1,1,7.289,0v1.38H.542ZM11.749,21.272a1.642,1.642,0,0,1-1.637,1.637H-2.011a1.641,1.641,0,0,1-1.637-1.637V7.208h3.1v2.22A.546.546,0,0,0,0,9.974a.546.546,0,0,0,.546-.546V7.208H7.837v2.22a.546.546,0,1,0,1.091,0V7.208h2.821Zm0,0",
  transform: "translate(4.733 0)",
  fill: "#fff"
});

var SvgBag = function SvgBag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.578,
    height: 24,
    viewBox: "0 0 17.578 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bag.8b4d9eef.svg";
export { ForwardRef as ReactComponent };